import { http } from '../http';

export class CommunityHubAPI {

    private static INSTANCE = new CommunityHubAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace  = 'api/admin/v1';

    public getCommunityList(params: any) {
        const endpoint =  `${this.namespace}/community/list`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header , params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
     public getHubDetail(hubId: any) {
        const endpoint =  `${this.namespace}/community/${hubId}`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header ).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public getcommunityHubCreate(data: any) {
        const endpoint =  `${this.namespace}/community`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header , data ).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public getUpdateCommunityHub(hubId: any, params: any) {
        const endpoint =  `${this.namespace}/community/${hubId}`;
        const header = http.getTokenHeaders();
        return http.put(endpoint, header , params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public getCreateHubContent(hubId: any, data: any) {
        const endpoint =  `${this.namespace}/community/${hubId}/contents`;
        const param = { contents: data };
        const header = http.getTokenHeaders();
        return http.post(endpoint, header , param ).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public getUpdateHubContent(hubId: any, params: any) {
        const endpoint =  `${this.namespace}/community/${hubId}/contents`;
        const header = http.getTokenHeaders();
        const data = { contents: params };
        return http.put(endpoint, header , data).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public removeHubContent(hubId: any, contentId: any, params: any) {
        const endpoint =  `${this.namespace}/community/${hubId}/contents/${contentId}`;
        const header = http.getTokenHeaders();
        return http.put(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public removeHub(hubId: any, params: any) {
        const endpoint =  `${this.namespace}/community/delete/${hubId}`;
        const header = http.getTokenHeaders();
        return http.put(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
}
export const communityHubAPI = CommunityHubAPI.instance;





